import { useEffect, useState } from "react";
import { BREAKPOINTS } from "@/ReactInit/Scripts/DashboardPage/utils/breakpoints";

const isBrowser = () =>
  typeof window !== "undefined" && typeof window.matchMedia !== "undefined";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (!isBrowser()) return false;
    return window.innerWidth < BREAKPOINTS.tablet;
  });

  useEffect(() => {
    if (!isBrowser()) return;

    const mediaQuery = window.matchMedia(
      `(max-width: ${BREAKPOINTS.tablet - 1}px)`
    );

    const update = () => setIsMobile(mediaQuery.matches);

    update();
    mediaQuery.addEventListener("change", update);

    return () => {
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  return isMobile;
}
